<template>
    <div class="q-layout q-layout--containerized">
      <template v-if="[1,2,3,5,6,19,21,22].includes(parseInt(selectedTemplate.templateId))">
        <div id="sport_menu" class="menu match-main-menu menu-inner-wrap" style="z-index: 501; max-width: unset !important;">
          <marketHeader></marketHeader>
          <gameHeader></gameHeader>
        </div>
        <template v-if="selectedTemplate.templateId == '6'">
          <div v-if="loadingScreen" class="loading" :class="{'theme01-root-loading':_theme==1,'theme02-root-loading':_theme==2}" id="loading-root-ele" style="z-index:500 !important">
            <div id="loading-root-main" class="la-line-scale">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <allBet2></allBet2>
        </template>
        <template v-else>
          <sportHeader></sportHeader>
        </template>
      </template>
      <div id="page-footer" class="clearfix">
            Copyright &copy; 2025 BeFun Score. {{arr_lang.home['HOME.ALL_RIGHT_RESERVED']}}
      </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import vueCookie from 'vue-cookie'
  import EventBus from '@/vue/events/event-bus'
  import sportHeader from '../sport/sportHeader.vue'
  import marketHeader from '../sport/marketHeader.vue'
  import loadingScreen from '@/vue/components/loadingScreen'
  import gameHeader from '../home/gameHeader.vue' 
  import allBetHeader from '../sport/allBet/allBetHeader'
  import moment from 'moment'
  import allBet2 from '../sport/allBet/allBet2'

  export default {
    components: {
      sportHeader,
      loadingScreen,
      marketHeader,
      gameHeader,
      allBetHeader,
      allBet2,
    },
    data() {
        return {
          showPasscodeCreation: false,
          pch: window.pch,
          pcTyp: '1', 
          token: window.token,
          isP: true,
          selectedSkinTheme:null,
          window: {
              width: 0,
              height: 0
          },
          userAccount: window.account.acccode,
          orientation:(window.outerWidth < window.outerHeight || (window.orientation!=undefined && window.orientation===0) || window.matchMedia("(orientation: portrait)").matches) ? 0 : 90,
          showPromoDetail: false,
          gameBanner : window._gameBanner,
          sel_edition: '3',
          langId: window._langid,
        }
    },
    computed:{
      ...mapGetters([
        'int_marketToggle',
        'loadingScreen',
        'arr_selectedTemplate',
        'userdetail',
        'passcode',
        'account',
        'noShowAgainList',
        'arr_leagues',
        'isParlay',
        'isSpecial',
        'bettingSelection',
        'bettingMessage',
        'arr_lang',
        'minSize',
        'isMobile',
        'skinTheme',
        'showFloating',
        'isShowBtModal',
        'isShowFilter',
        'showFavEvents',
        'allowLanscape',
        'arr_sportAll',
        'notSupportParlay',
        '_theme',
      ]),
      selectedTemplate: function(){
        return this.$store.getters.arr_selectedTemplate
      }
    },
    methods: {
        actionPasscodeReminder(data) {
          this.showPasscodeCreation = data
        },
        getSelectedLeagueOdds() {
          this.$store.commit('S_ODD', false)
          this.$store.commit('SHOW_CALENDAR', false)
          this.$store.commit('SELECTED_LEAGUES', this.arr_leagues)

          var templateId = this.$store.getters.int_marketToggle == '3' ? 2 : 3
          var subTemplateId = this.$store.getters.int_marketToggle == '3' ? 1 : this.$store.getters.arr_selectedTemplate.subTemplateId

          this.$store.dispatch('changeTemplate', {
              templateId: templateId,
              marketKey: this.$store.getters.int_selectedMarket,
              plytype: 1,
              bettypeid: this.$store.getters.arr_selectedTemplate.bettypeid,
              sportId: this.$store.getters.arr_selectedTemplate.sportId,
              subTemplateId: subTemplateId,
          })
        },
        handleResize() {

            this.orientation = (window.outerWidth < window.outerHeight || (window.orientation!=undefined && window.orientation===0) || window.matchMedia("(orientation: portrait)").matches) ? 0 : 90;
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            if(window.innerWidth < this.minSize){
              this.$store.commit('IS_MOBILE', true)
            }else{
              this.$store.commit('IS_MOBILE', false)
            }
        },
        clickEdition(edition){
          this.sel_edition = edition
        },
        selectEdition(){
            let Vue = this;
            var bettypeid = null
            var plytype = 1
            var subTemplateId = 1
            Vue.$store.commit("GAMEBANNER_SELECTED", false);
            $( ".scroller" ).scrollTop( 0 );
            Vue.$store.commit('IS_HIDE_LEAGUE', false)
            var container = $(".sub-m-menu");
            var container2 = $(".sub-background");
            if (container || container2) {
                container.hide();
                container2.hide();
            }
            if(Vue.sel_edition == '3'){
              var sprtId = 'N1';
              let market = 1
              Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sprtId)
              this.$store.dispatch('getEventList', {
                market: market,
                token: token.arr_2,
                callback: ((res) => {
                  var today = !_.isUndefined(this.$store.getters.arr_sportCountMarket.today)?this.$store.getters.arr_sportCountMarket.today[1]:0;
                  var live = !_.isUndefined(this.$store.getters.arr_sportCountMarket.live)?this.$store.getters.arr_sportCountMarket.live[1]:0;

                  var tdRbevent = today + live;
                  if(tdRbevent > 0){
                    this.$store.commit('CURRENT_TAB', 1)
                    this.$store.commit('SHOW_CALENDAR', false)
                    this.$store.commit('MARKETTOGGLE', market) 
                    if((account.previewFlag==undefined) || (account.previewFlag && market!='1')){//(account.previewFlag==undefined && market!='3') ||
                      var btemplateId = 1;
                    } else if ((account.previewFlag && market=='1')){ //|| (account.previewFlag==undefined && market=='3')
                      var btemplateId = 3;
                      this.$store.commit('SEL_MATCH', true)
                    } 
                    if(sprtId!='' && sprtId != 'G98' && !this.isGameBannerSelected){
                      if(this.$store.getters.arr_sportList != null && Object.keys(this.$store.getters.arr_sportList).length > 0){
                        let current1stSport = Object.keys(res.totalMatch)[0]
                        if(market==1){
                        // check have rb sport or not
                          if(this.$store.getters.arr_sportCountMarket.live && Object.keys(this.$store.getters.arr_sportCountMarket.live).length>0){
                            let rbSport = Object.keys(this.$store.getters.arr_sportCountMarket.live)[0]
                            if(rbSport<=current1stSport){
                              current1stSport = rbSport
                            }
                          }
                        }

                        let getSport = _.filter(this.$store.getters.titleSport, function(x){
                          return _.includes(x.sid, current1stSport)
                        })
                        //sprtId = getSport[0].id
                        bettypeid = sprtId.split('')
                        if(bettypeid.length >= 3){
                          bettypeid = bettypeid[1]+""+bettypeid[2]
                        }else{
                          bettypeid = bettypeid[1]
                        }
                      }
                    }
                    
                    // sprtId = (this.$store.getters.arr_selectedTemplate.sportId == undefined || this.$store.getters.arr_selectedTemplate.sportId == 'G98') ? sprtId : this.$store.getters.arr_selectedTemplate.sportId;

                      this.$store.dispatch('changeTemplate', {
                        templateId: btemplateId,
                        // templateId: 2, //4
                        marketKey: market,
                        plytype: plytype,
                        bettypeid: bettypeid,
                        sportId: sprtId,
                        subTemplateId: subTemplateId,
                      })
                    
                    EventBus.$emit('enableLoading', false)

                    this.$nextTick(() => {
                      this.$store.commit('SELECTED_MARKET', market)
                      EventBus.$emit('sportTemplate', sprtId)
                      $('.chkbox_league').prop('checked', false)
                    })
                  }
                }).bind(this)
              })
              
              $.ajax({
                  url: _baseUrl + '/account-def-settings',
                  type: 'get',
                  data: {
                      action: 'updateAccountSportSetting',
                      edition: 3,
                      startedtab: 1,
                      sport_id: 1
                  }
              }).done(response => {
              })
              Vue.$store.commit('EDITIONSTAND', Vue.sel_edition)
            }
            
	          Vue.$store.commit('SHOW_FLOATING', false)
            $( ".scroll" ).scrollTop( 0 );
            Vue.$store.commit('VIRTUAL_DATA_LIST', [])
            Vue.$store.commit('LOADGAMEHEADER', false)
            // Vue.$store.commit('LOADINGSCREEN',true)
            Vue.$store.commit('EVENTLIST', [])
            Vue.$store.commit('TODAYRBEVENTLIST', [])
            Vue.$store.commit('SWIPE_MODE', 1)
            $('.odd-t-i-wrapper').removeClass('status2') // swipe right
            $('.standard-odd-l-w').removeClass('status2')
            Vue.$store.commit('SORTEDEVENTLIST', [])
            Vue.$store.commit('COOKIE_LEAGUE', {
                remove : true,
            })
            EventBus.$emit('refreshSportTable')
        },
        getAllSportCount(comid){
          // 60 sec to get once
          var Vue = this

          Vue.$store.dispatch('getSportCount');
          Vue.$store.dispatch('getSportCountByMarket');

          setInterval(function(){
              Vue.$store.dispatch('getSportCount');
              Vue.$store.dispatch('getSportCountByMarket');
          }, 60000)
        },
        async  randomSleep(){
          await this.sleep(500);
        },
        async sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        },
    },
    beforeMount: function(){
      if(vueCookie.get('UID') && JSON.parse(vueCookie.get('UID')).usrn) {
        var usrn = JSON.parse(vueCookie.get('UID')).usrn
        if(usrn == '-1' || !JSON.parse(vueCookie.get('UID')).nsid){
          this.isP = true
        } else {
          this.isP = false
        }
      }
      EventBus.$on('enableLoading',(params) => {
        this.$store.commit('REFRESHSCREEN',params)
      })
      if(!this.account.previewFlag){
        this.$store.commit('SET_ACC_CHIP_SETTING')
      }
      var sprt = 'N1';
      // this.$store.commit('EDITIONSTAND', account.default['def_edition'])
      this.$store.commit('DEFAULT_SPORT',sprt)
      this.$store.commit('SELECTED_TEMPLATE', {
        templateId : 1,
        sportId: sprt
      })

      if(vueCookie.get(window.compcode + '_xrmd')) {
        this.$store.commit('NO_SHOW_AGAIN_LIST',JSON.parse(vueCookie.get(window.compcode + '_xrmd')) )
        this.$store.commit('SHOW_PASSCODE_REMINDER', false)
      }

      if(!this.account.isApi && this.pch && this.pch != '' && this.account.showReminder != false) {
        this.showPasscodeCreation = true
        this.pcTyp = '2'
      // } else if( (this.userdetail.usrn !== this.account.acccode || 
      } else if( (this.userdetail.usrn !== this.account.usrn || 
        (this.userdetail && (this.userdetail.usrn === '-1' || typeof this.userdetail.nsid === 'undefined') && 
        this.passcode.showReminder)) && 
        this.passcode.noShowAgainList.indexOf(this.account.acccode) == -1 &&
        this.account.showReminder != false &&
        !this.account.isApi ) {
        this.showPasscodeCreation = true
      }
      if(localStorage.getItem('bts')) {
          var bts = JSON.parse(localStorage.getItem('bts'))
          var selectedTemplate = this.arr_selectedTemplate
          
          this.$store.commit('SELECTED_TEMPLATE', {
              templateId : bts.data!='' && bts.data.length>0 ? bts.tempId : selectedTemplate.templateId,
              subTemplateId: bts.data!='' && bts.data.length>0 ? bts.selection : 1,
          })

          if(bts.data!=''&&bts.data.length>0){
            this.$store.commit('IS_PARLAY', bts.isParlay)
            this.$store.commit('IS_OTR', bts.isOtr)
            this.$store.commit('IS_COMBOBET', bts.isCombo)

            this.$store.dispatch('getLatestInfo', {
                token: token.arr_2
            });
          }
      }
      if(this.$store.getters._sortHot){
        this.$store.commit('SORT_HOT', this.$store.getters._sortHot)
      }
      if(this.$store.getters._editionStand){
        this.$store.commit('EDITIONSTAND', this.$store.getters._editionStand)
      }
      if(this.$store.getters._betterOdds){
        this.$store.commit('BETTER_ODDS', this.$store.getters._betterOdds)
      }
      if(this.$store.getters._filterLeague){
        this.$store.commit('FILTER_LEAGUE', this.$store.getters._filterLeague)
      }
      if(this.$store.getters._theme){
        this.$store.commit('SKIN_THEME', this.$store.getters._theme)
        if(this.$store.getters._theme == 2){
          document.documentElement.classList.toggle('theme02');
        }
      }

      if(localStorage.getItem('simDisp')) {
        this.$store.commit('SIM_DISP', JSON.parse(localStorage.getItem('simDisp')))
      }

      this.$store.commit('DATE_LIST',window.completedDateList)
      
      var date = new moment().utcOffset(this.$store.getters.selected_timezone).format("YYYY-MM-DD");
      this.$store.commit('PARLAYDATELIST',window.earlyDateList)
      this.$store.commit('SELECTEDDATE', date) // window.earlyDateList[0]
    },
    mounted(){
      // is safari
      let Vue=this
      $('.gridContainer').css('overflow-y','auto');
      // this.getAllSportCount(this.account.comId)
      $(document).ready(function () {
        $( "#loading-root-ele" ).hide();
        var lastScrollTop = 0;
        $('.scroll, #sportTable, #simpleSportTable').scroll(function(){
          var st = $(this).scrollTop();
          if($(window).scrollTop() >= $('.scroll').offset().top + $('.scroll').outerHeight() - window.innerHeight){
            $( ".loading-more-container" ).show();
          }else{
            $( ".loading-more-container" ).hide();
          }
          Vue.randomSleep();
          setTimeout(function(){
            var simpleClass = 'simple'
            if(Vue.gameBanner) {
              simpleClass = 'simple1'
            }
            var checDV= $( ".sub-menu-date-w" ).hasClass( simpleClass );
            var checDV2= $( ".container-menu-w" ).hasClass( "scrolling-down" );
            var checDV3= $( ".container-menu-w" ).hasClass( "scrolling-down" );
            if (st > lastScrollTop){
              if(!checDV){
                $( ".sub-menu-date-w" ).addClass( simpleClass );
                $( ".sport-m-container" ).addClass( simpleClass );
                $( ".list-scroll-to-topr" ).show();
              }
              if(checDV2){
                $( ".container-menu-w" ).removeClass( "scrolling-down" );
              }
              if(!checDV3){
                $( ".container-menu-w" ).addClass( "scrolling-up" );
              }
            } else {
              if(checDV){
                $( ".list-scroll-to-topr" ).hide();
                $( ".sub-menu-date-w" ).removeClass( simpleClass );
                $( ".sport-m-container" ).removeClass( simpleClass );
              }
              if(!checDV2){
                $( ".container-menu-w" ).removeClass( "scrolling-up" );
                $( ".container-menu-w" ).addClass( "scrolling-down" );
              }
            }
            lastScrollTop = st;
          }, 100);
        });
      });

      if(window.hideLeagues && this.$store.getters.isHideLeague && this.$store.getters.isHideLeague.length == 0 && this.$store.getters.titleSport && this.$store.getters.titleSport.length >0) {
        let vue = this
        var sprts={}
        sprts.sport = 1
        sprts.status = true
        _.forEach(this.$store.getters.titleSport, function(val, key){
            if(val.sid && val.sid.length > 0){
              sprts.sport = val.sid[0]
              vue.$store.commit('IS_HIDE_LEAGUE', sprts)
            }
        })
      }
      var playframe_original_style;
      var playframe_original_scare;
      var playframe_original_or; 
      let vue = this
        window.addEventListener("message", function(ev){
            if (typeof ev.data !== "object") return;
            if (!ev.data.type) return;
            if (ev.data.type !== "full_screen_click") return;
            var playframe_message = ev.data.message;
            var playframe = document.getElementById("bdIframe"); // can replace with your iframe id

            if (Object.keys(playframe_message).length > 0){
                var playframe_fullscreen_style = "";
                Object.keys(playframe_message).forEach((val, idx) => {
                    var style_name = val;
                    playframe_fullscreen_style += `${style_name}: ${playframe_message[val]};`;
                });
                playframe_original_style = playframe.getAttribute("style");
                playframe.setAttribute("style", playframe_fullscreen_style);
                playframe_original_scare= $('#overview').css('transform');
                playframe_original_or = vue.orientation
                if(playframe_original_scare!='none'){
                  if(playframe_original_or==0){
                     Vue.$store.commit('TV_FULL_SCREEN', '1'); // mobile portrail 
                     $('.title-events-mobile-wrap').addClass('fulltv')
                  }else{
                     Vue.$store.commit('TV_FULL_SCREEN', '2'); // mobile landscap
                  }
                }
                $('#overview').addClass('fulltv')
                
            } else{
                Vue.$store.commit('TV_FULL_SCREEN', '0')
                if(playframe_original_style != null){
                    playframe.setAttribute("style", playframe_original_style);
                }
                else{
                    playframe.removeAttribute("style");
                }
                 $('#overview').removeClass('fulltv')
                 $('.title-events-mobile-wrap').removeClass('fulltv')
            }
        });
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }
 
</script>
<style lang="scss">
    @import "~@/styles/home/match_main"; 
    @import "~@/styles/home/app";
    @import "~@/styles/home/user-h5"; 
    @import "~@/styles/home/chunk-vendors";
 //   @import "~@/styles/home/user-h5-details";
   
   
</style>



// WEBPACK FOOTER //
// resources/score/vue/apps/home/home.vue